import { useMainLayoutTranslationsENUS } from './en-US';
import { useMainLayoutTranslationsESES } from './es-ES';
import { useMainLayoutTranslationsPTBR } from './pt-BR';

export const useMainLayoutTranslations = () => {
  const ptBR = useMainLayoutTranslationsPTBR();
  const enUS = useMainLayoutTranslationsENUS();
  const esES = useMainLayoutTranslationsESES();

  return {
    ptBR,
    enUS,
    esES,
  };
};
